import { Component } from '@angular/core';
import { PillarPagesTemp } from "../../components/pillar-pages-temp/pillar-pages-temp";

@Component({
  selector: 'app-student-industry-credentials',
  standalone: true,
  imports: [PillarPagesTemp],
  templateUrl: './student-industry-credentials.html',
  styleUrl: './student-industry-credentials.scss',
})
export class StudentIndustryCredentials {
 
}
